export const BASE = "BETTING/";
export const BET_SUBMITTED = BASE + "BET_SUBMITTED";
export const BET_ADDED_TO_SLIP = BASE + "BET_ADDED_TO_SLIP";
export const MATCH_PAGE_VISITED = BASE + "MATCH_PAGE_VISITED";
